/**
 * Phase 17 — Bestellungen lesen: entity_orders + merged Blob.
 */

import { listAggregateOrders } from '../infrastructure/storage/domainAggregateStore';
import { listEntityOrders } from '../infrastructure/storage/entityAggregateStore';
import { readBlobFirstWithAggregateFallback } from './canonicalEntityRead';
import { readSyncWithBlobPriority, readArrayFieldFromMergedBlob } from './businessStateSync';

/** @type {Map<string, object[]>} */
const ordersReadCache = new Map();

export function readOrdersFromMergedBlob(businessId) {
  return readArrayFieldFromMergedBlob(businessId, 'orders', getCachedOrdersRead);
}

export async function readOrdersFromBestSource(businessId) {
  return readBlobFirstWithAggregateFallback(
    businessId,
    readOrdersFromMergedBlob,
    listAggregateOrders,
    listEntityOrders,
    ['id', 'orderId']
  );
}

export async function refreshOrdersReadCache(businessId, preloaded) {
  const orders =
    preloaded !== undefined
      ? Array.isArray(preloaded)
        ? preloaded
        : []
      : await readOrdersFromBestSource(businessId);
  if (businessId) {
    ordersReadCache.set(String(businessId), orders);
  }
  return orders;
}

export function getCachedOrdersRead(businessId) {
  if (!businessId) return null;
  return ordersReadCache.get(String(businessId)) ?? null;
}

export function clearOrdersReadCache(businessId) {
  if (businessId) {
    ordersReadCache.delete(String(businessId));
  } else {
    ordersReadCache.clear();
  }
}

export function readOrdersSyncForBusiness(businessId) {
  return readSyncWithBlobPriority(
    businessId,
    readOrdersFromMergedBlob,
    getCachedOrdersRead,
    'id',
    'orderId'
  );
}
